const OVERLAY_MARGIN_OFFSET = 4

export const positionLogic = (
  rect,
  overlayCur,
  position,
  flipXTreshold = 16,
  flipYTreshold = 240,
) => {
  const overlayRect = overlayCur.getBoundingClientRect()
  const overlayWidth = overlayRect.width
  const overlayHeight = overlayRect.height
  const windowWidth = window.innerWidth
  const windowHeight = window.innerHeight

  const FLIP_TRESHOLD_X = overlayWidth || flipXTreshold
  const FLIP_TRESHOLD_Y = overlayHeight || flipYTreshold

  const calculateXOffset = (left: number, right: number) => {
    const rectWidth = right - left
    const isNearlyFullWidth = rectWidth >= windowWidth * 0.4
    const moveLeft = windowWidth - right < FLIP_TRESHOLD_X
    const moveRight = left < FLIP_TRESHOLD_X

    if (isNearlyFullWidth) {
      return 'normal'
    }
    if (moveLeft && !moveRight) {
      return 'moveLeft'
    }
    if (moveRight) {
      return 'moveRight'
    }

    return 'normal'
  }

  const getTranslateX = (
    moveDirection: string,
    triggerWidth: number,
    isCentered: boolean,
  ) => {
    if (moveDirection === 'moveLeft') {
      return `calc(-100% + ${triggerWidth}px)`
    }
    if (moveDirection === 'moveRight') {
      return `-${triggerWidth / 2}px`
    }
    return isCentered ? `-${overlayWidth / 2}px` : '0px'
  }

  if (position === 'center') {
    overlayCur.style.left = '50%'
    overlayCur.style.top = '50%'
    overlayCur.style.transform = 'translate(-50%, -50%)'
    overlayCur.style.maxHeight = `calc(100% - ${OVERLAY_MARGIN_OFFSET * 2}px)`
    overlayCur.style.maxWidth = `calc(100% - ${OVERLAY_MARGIN_OFFSET * 2}px)`
    return
  }

  if (position === 'left') {
    const hasSpaceLeft = rect.left - OVERLAY_MARGIN_OFFSET >= FLIP_TRESHOLD_X

    overlayCur.style.top = `${rect.top}px`

    if (hasSpaceLeft) {
      overlayCur.style.left = `${rect.left - OVERLAY_MARGIN_OFFSET}px`
      overlayCur.style.transform = 'translateX(-100%)'
    } else {
      overlayCur.style.left = `${rect.right + OVERLAY_MARGIN_OFFSET}px`
      overlayCur.style.transform = 'translateX(0)'
    }

    overlayCur.style.maxHeight = `${windowHeight - rect.top - OVERLAY_MARGIN_OFFSET}px`
    overlayCur.style.maxWidth = hasSpaceLeft
      ? `${rect.left - OVERLAY_MARGIN_OFFSET * 2}px`
      : `${windowWidth - rect.right - OVERLAY_MARGIN_OFFSET * 2}px`
    return
  }

  if (position === 'right') {
    const hasSpaceRight = windowWidth - rect.right >= FLIP_TRESHOLD_X

    overlayCur.style.top = `${rect.top}px`

    if (hasSpaceRight) {
      overlayCur.style.left = `${rect.right + OVERLAY_MARGIN_OFFSET}px`
      overlayCur.style.transform = 'translateX(0)'
    } else {
      overlayCur.style.left = `${rect.left - OVERLAY_MARGIN_OFFSET}px`
      overlayCur.style.transform = 'translateX(-100%)'
    }

    overlayCur.style.maxHeight = `${windowHeight - rect.top - OVERLAY_MARGIN_OFFSET}px`
    overlayCur.style.maxWidth = hasSpaceRight
      ? `${windowWidth - rect.right - OVERLAY_MARGIN_OFFSET * 2}px`
      : `${rect.left - OVERLAY_MARGIN_OFFSET * 2}px`
    return
  }

  if (position === 'top' || position === 'top-center') {
    const hasSpaceTop = rect.top - OVERLAY_MARGIN_OFFSET >= FLIP_TRESHOLD_Y
    const isCentered = position === 'top-center'
    const xOffset = calculateXOffset(rect.left, rect.right)

    const centerX = rect.left + rect.width / 2
    overlayCur.style.left = isCentered ? `${centerX}px` : `${rect.left}px`

    const translateX = getTranslateX(xOffset, rect.width, isCentered)

    if (hasSpaceTop) {
      overlayCur.style.top = `${rect.top - OVERLAY_MARGIN_OFFSET}px`
      overlayCur.style.transform = `translate(${translateX}, -100%)`
      overlayCur.style.maxHeight = `${rect.top - OVERLAY_MARGIN_OFFSET * 2}px`
    } else {
      overlayCur.style.top = `${rect.bottom + OVERLAY_MARGIN_OFFSET}px`
      overlayCur.style.transform = `translate(${translateX}, 0)`
      overlayCur.style.maxHeight = `${windowHeight - rect.bottom - OVERLAY_MARGIN_OFFSET * 2}px`
    }

    overlayCur.style.maxWidth = `${windowWidth - OVERLAY_MARGIN_OFFSET * 2}px`
    return
  }

  if (position === 'bottom' || position === 'bottom-center') {
    const hasSpaceBottom = windowHeight - rect.bottom >= FLIP_TRESHOLD_Y
    const isCentered = position === 'bottom-center'
    const xOffset = calculateXOffset(rect.left, rect.right)

    const centerX = rect.left + rect.width / 2
    overlayCur.style.left = isCentered ? `${centerX}px` : `${rect.left}px`

    const translateX = getTranslateX(xOffset, rect.width, isCentered)

    if (hasSpaceBottom) {
      overlayCur.style.top = `${rect.bottom + OVERLAY_MARGIN_OFFSET}px`
      overlayCur.style.transform = `translate(${translateX}, 0px)`
      overlayCur.style.maxHeight = `${windowHeight - rect.bottom - OVERLAY_MARGIN_OFFSET * 2}px`
    } else {
      overlayCur.style.top = `${rect.top - OVERLAY_MARGIN_OFFSET}px`
      overlayCur.style.transform = `translate(${translateX}, -100%)`
      overlayCur.style.maxHeight = `${rect.top - OVERLAY_MARGIN_OFFSET * 2}px`
    }

    //  overlayCur.style.maxWidth = `${windowWidth - OVERLAY_MARGIN_OFFSET * 2}px`
    return
  }
}
